import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { type IDistributedDispenser } from './DistributedChargerPanelRemoteCommands'
import { useAppDispatch, useAppSelector } from '../../../rmsReduxStore/rmsReduxHooks'
import { fetchDistributedChargerDispensers, getChargerReducer } from '../../../rmsReduxStore/reduxExports'

// Fetches the dispensers (with their connectors) of the current charger when it is a distributed charger
const useDistributedChargerDispensers = (): { isDistributedCharger: boolean, dispensers: IDistributedDispenser[] } => {
  const { individualChargerDetail, distributedChargerDispensers } = useAppSelector(getChargerReducer)
  const dispatch = useAppDispatch()
  const location = useLocation()
  const chargerId = location?.state?.chargerId
  const isDistributedCharger = individualChargerDetail?.productType === 'Power Cube'

  useEffect(() => {
    if (isDistributedCharger && chargerId) {
      dispatch(fetchDistributedChargerDispensers({ chargerId }))
    }
  }, [isDistributedCharger, chargerId])

  const dispensers = useMemo<IDistributedDispenser[]>(() => {
    return distributedChargerDispensers?.map((dispenser) => ({
      dispenserNumber: dispenser?.dispenserNumber,
      connectors: dispenser?.connectors?.map((connector) => ({
        radioButtonId: connector?.id,
        radioButtonLabel: 'C' + connector?.connectorNumber + ' (' + connector?.connectorType + ')'
      })) ?? []
    })) ?? []
  }, [distributedChargerDispensers])

  return { isDistributedCharger, dispensers }
}

export default useDistributedChargerDispensers
